import { render, staticRenderFns } from "./IpsBadge.vue?vue&type=template&id=f44f65fa&scoped=true"
import script from "./IpsBadge.vue?vue&type=script&lang=js"
export * from "./IpsBadge.vue?vue&type=script&lang=js"
import style0 from "./IpsBadge.vue?vue&type=style&index=0&id=f44f65fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44f65fa",
  null
  
)

export default component.exports